<template>
  <div>
    <el-form :model="form" :rules="rules" ref="form">
      <TopBarTitleComponent title="Directorio" :showBackIcon="false">
        <template slot="right-area">
          <div class="d-flex justify-content-end align-items-center">
            <ButtonPrimaryComponent
              :title="isEditing ? 'Guardar' : 'Crear'"
              @onSaveClick="handleSaveClick"
            />
            <button
              class="topbar-close-btn ml-3"
              type="button"
              @click="$emit('close')"
              title="Cerrar"
            >
              <i class="el-icon-close"></i>
            </button>
          </div>
        </template>
      </TopBarTitleComponent>

      <div class="dir-content-body">
        <div class="dir-breadcrumb">
          <span>Directorio</span>
          <span class="dir-breadcrumb-sep">›</span>
          <span class="dir-breadcrumb-current">
            {{ isEditing ? "Editar Contacto" : "Nuevo Contacto" }}
          </span>
        </div>

        <div class="dir-info-section">
          <h5 class="dir-info-section-title">Foto de contacto</h5>
          <FileUploadComponent
            icon="el-icon-user"
            title="Subir Foto"
            className="image-profile"
            :showFileList="false"
            @fileBase64="onFileBase64"
          />
        </div>

        <div class="dir-info-section">
          <h5 class="dir-info-section-title">Información de Contacto</h5>
          <b-row>
            <b-col sm="12" md="6">
              <el-form-item prop="name">
                <label class="font-semi-bold m-0">Nombre de contacto</label>
                <el-input type="text" v-model="form.name" />
              </el-form-item>
            </b-col>
            <b-col sm="12" md="6">
              <el-form-item prop="email">
                <label class="font-semi-bold m-0">Correo</label>
                <el-input type="text" v-model="form.email" />
              </el-form-item>
            </b-col>
            <b-col sm="12" md="6">
              <el-form-item>
                <label class="font-semi-bold m-0">Teléfono</label>
                <el-input type="text" v-model="form.phone" />
              </el-form-item>
            </b-col>
            <b-col sm="12" md="6">
              <el-form-item>
                <label class="font-semi-bold m-0">Cargo</label>
                <el-input type="text" v-model="form.position" />
              </el-form-item>
            </b-col>
          </b-row>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
import TopBarTitleComponent from "../../components/TopBarTitle";
import FileUploadComponent from "../../components/FileUpload.vue";
import ButtonPrimaryComponent from "../../components/ButtonPrimary";
import businessService from "../services/businessService";
import Validate from "@/assets/validate";

export default {
  name: "EditContact",
  components: {
    TopBarTitleComponent,
    FileUploadComponent,
    ButtonPrimaryComponent
  },
  props: {
    contact: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      form: {
        id: "",
        name: "",
        position: "",
        phone: "",
        email: "",
        image: ""
      },
      rules: {
        name: [Validate.rules.required()],
        email: [Validate.rules.required(), Validate.rules.email()]
      }
    };
  },
  computed: {
    isEditing() {
      return !!(this.contact && this.contact.id);
    }
  },
  methods: {
    onFileBase64(base64) {
      this.form.image = base64;
    },
    handleSaveClick() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          this.$store.dispatch("toggleRequestLoading");
          try {
            const serviceCall = this.isEditing
              ? businessService.updateContactId(this.form)
              : businessService.addContact(this.form);
            let response = await serviceCall.finally(() => {
              this.$store.dispatch("toggleRequestLoading");
            });
            const { success, message } = response.data;
            if (success) {
              this.$refs.form.resetFields();
              this.$root.$emit("cleanFileUpload");
              this.form.image = "";
              this.$notifications.success({ message });
              this.$emit("onSuccess");
            }
          } catch (error) {
            return false;
          }
        }
      });
    }
  },
  created() {
    if (this.contact && this.contact.id) {
      this.form = { ...this.contact };
    }
  }
};
</script>

<style lang="scss" scoped>
.topbar-close-btn {
  width: 36px;
  height: 36px;
  border: none;
  background: transparent;
  cursor: pointer;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #909399;
  transition: all 0.15s;

  &:hover {
    background: #f0f2f7;
    color: #31355c;
  }
}

.el-form-item {
  margin-bottom: 8px !important;
}
</style>
